import { ScreenHeader } from '../components/ScreenHeader';

function Rules() {
  return (
    <div className="app home rules-page">
      <ScreenHeader />
      <h1 className="page-title">Правила</h1>

      <article className="rules">
        <section>
          <h2>Как играть</h2>
          <p>
            Tabys Games — это сезонная арена. Заходите в любую игру на полке, закрывайте раунды
            и копите энергию. Чем чище прохождение, тем больше энергии падает на баланс.
          </p>
        </section>

        <section>
          <h2>Энергия</h2>
          <p>
            Энергия — главная валюта сезона. Она копится за победы, серии и скорость. Баланс на
            главной — это ваша энергия здесь и сейчас. Тратьте её нельзя: она только растёт и
            двигает вас по лидерборду.
          </p>
        </section>

        <section>
          <h2>Лидерборд</h2>
          <p>
            Таблица обновляется за неделю и за месяц. Цель простая: обойти остальных игроков
            по энергии и удержаться в топе до конца периода. Первые места видны всем — и именно
            они забирают призы сезона.
          </p>
        </section>

        <section>
          <h2>Призы сезона</h2>
          <p>Выбивайтесь в лидеры и забирайте награды Tabys Pro:</p>
          <ul className="prize-list">
            <li>
              <span>0% на торговлю</span>
              Комиссия на сделки обнуляется на срок сезона.
            </li>
            <li>
              <span>Акции в портфель</span>
              Реальные бумаги зачисляются на ваш счёт Tabys Pro.
            </li>
            <li>
              <span>Мерч Tabys Pro</span>
              Лимитированный набор для тех, кто закрыл сезон в топе.
            </li>
            <li>
              <span>Эксклюзивные билеты на DEMO DAY 2026</span>
              Проход на закрытую сцену, без общей очереди.
            </li>
          </ul>
        </section>

        <section>
          <h2>Fair play</h2>
          <p>
            Один аккаунт — один игрок. Накрутка энергии, мультиаккаунты и срывы сессии во время
            начисления очков обнуляют прогресс периода. Играйте честно, копите энергию, забирайте
            призы.
          </p>
        </section>
      </article>
    </div>
  );
}

export default Rules;
